<div class="line-goal-wrapper">
    <div *ngIf="withTitle" class="tw-flex">
        <div class="tw-text-black tw-font-bold tw-font-sm" translate>v3-goal-line-title-week-goal</div>
    </div>
    <div class="tw-flex-grow progressbar-wrapper">
        <div
            [attr.tabindex]="0"
            class="dot"
            #dotTooltip="ngbTooltip"
            triggers="none"
            [disableTooltip]="completed || !started"
            ngbTooltip="{{ statistics.goal.current.seconds | time: { type: 'short', round: 'down' } }}"
            tooltipClass="tooltip-secondary-md"
            container="body"
            (mouseenter)="dotTooltip.open()"
            (mouseleave)="dotTooltip.close()"
        >
            <app-bar
                [value]="percentComplete"
                [background]="'primary-50'"
                size="md"
                severity="success"
                label="{{ 'statistics.goal.label' | translate }}"
            ></app-bar>
        </div>
        <div aria-hidden="true" class="tw-flex tw-font-2xs tw-font-semibold tw-text-black tw-mt-1">
            <span>{{ 0 | time: { type: 'short', round: 'down' } }}</span>
            <span class="tw-ml-auto">{{ statistics.goal.declarated.seconds | time: { type: 'short' } }}</span>
        </div>
    </div>
    <div>
        <span
            class="tw-inline-block tw-w-6 tw-h-6"
            [attr.tabindex]="0"
            role="status"
            [attr.aria-label]="(statistics.goal.declarated.seconds | time: { type: 'short' }) + ' ' + ('v3-global-goal' | translate)"
            [ngbTooltip]="(statistics.goal.declarated.seconds | time: { type: 'short' }) + ' ' + ('v3-global-goal' | translate)"
            tooltipClass="tooltip-secondary-md"
        >
            <app-icon name="goal" class="tw-w-6 tw-h-6"></app-icon>
        </span>
    </div>
</div>
